import { render } from "./MarcaPadrao.vue?vue&type=template&id=d9681c5a&scoped=true&ts=true"
import script from "./MarcaPadrao.vue?vue&type=script&lang=ts"
export * from "./MarcaPadrao.vue?vue&type=script&lang=ts"

import "./MarcaPadrao.vue?vue&type=style&index=0&id=d9681c5a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9681c5a"]])

export default __exports__